/* @flow */

import $ from 'jquery';

import efeitosIniciais from './efeitos-iniciais';
import eventoSubmitNoLogin from './evento-submit-no-login';

$(() => {
    efeitosIniciais();
    eventoSubmitNoLogin();
});



// WEBPACK FOOTER //
// ./app/admin/login/index.js